/* tslint:disable */

/* eslint-disable */

/**
 * Jucy Rentals Rest API
 * In this document you will find all the API methods we provide along with explanations for parameters and response examples.  If you are using the legacy V2 API, [view the V2 documentation here.](/docs/v2)  ## Interactive Test Client  Experiment with live APIs using the **[Interactive Test Client](/v3/swagger)** .  ## Authentication Include your API key in the as the `accountKey` query parameter or `X-API-KEY` http header.  ## Query Availability, Pricing and Secondary Products  1. **[listSites](/v3/swagger/static/index.html#/sites/listSites)** Returns all sites, their short codes, office hours, and holidays for each fleet type. Using the information returned from `listSites`, you can create a request to `availabilitySearch`.  2. **[availabilitySearch](/v3/swagger/static/index.html#/trip/availabilitySearch)** Retrieves all vehicle categories that are potentially available for hire for the specified fleet type from the given locations, and given dates. Includes pricing and any mandatory fees. Note that pricing covers only the vehicle hire, excluding secondary and mandatory products by default.  2. **[tripInfo](/v3/swagger/static/index.html#/trip/tripInfo)** Provides additional trip information using the location and fleet category codes from `listSites` and `availabilitySearch`. The response includes available excess reduction and secondary products.  ## Create quotes, bookings and updating  existing bookings.  1. **[emailQuote](/v3/swagger/static/index.html#/quotes/emailQuote)** or **[createBooking](/v3/swagger/static/index.html#/reservations/createBooking)** Using details gathered from `tripInfo` create a booking or a quote. Quotes will hold pricing for a limited time, while bookings will be confirmed immediately. The **[convertQuote](/v3/swagger/static/index.html#/quotes/convertQuote)** endpoint may be called to convert a quote in to a booking  2. **[updateReservation](/v3/swagger/static/index.html#/reservations/updateReservation)** Optionally makes changes to an existing booking and quotes.
 *
 * The version of the OpenAPI document: 3.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { dateToString, stringToDate } from '../runtime';
import type { CurrencyValue } from './CurrencyValue';
import { CurrencyValueFromJSON, CurrencyValueFromJSONTyped, CurrencyValueToJSON } from './CurrencyValue';
import type { FerrySailingOrder } from './FerrySailingOrder';
import { FerrySailingOrderFromJSON, FerrySailingOrderFromJSONTyped, FerrySailingOrderToJSON } from './FerrySailingOrder';

/**
 *
 * @export
 * @interface FerryGetSailingsResponse
 */
export interface FerryGetSailingsResponse {
    /**
     *
     * @type {CurrencyValue}
     * @memberof FerryGetSailingsResponse
     */
    total: CurrencyValue;
    /**
     *
     * @type {FerrySailingOrder}
     * @memberof FerryGetSailingsResponse
     */
    outboundTrip: FerrySailingOrder;
    /**
     *
     * @type {FerrySailingOrder}
     * @memberof FerryGetSailingsResponse
     */
    returnTrip?: FerrySailingOrder;
}

/**
 * Check if a given object implements the FerryGetSailingsResponse interface.
 */
export function instanceOfFerryGetSailingsResponse(value: object): value is FerryGetSailingsResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('outboundTrip' in value) || value['outboundTrip'] === undefined) return false;
    return true;
}

export function FerryGetSailingsResponseFromJSON(json: any): FerryGetSailingsResponse {
    return FerryGetSailingsResponseFromJSONTyped(json, false);
}

export function FerryGetSailingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FerryGetSailingsResponse {
    if (json == null) {
        return json;
    }
    return {
        total: CurrencyValueFromJSON(json['total']),
        outboundTrip: FerrySailingOrderFromJSON(json['outboundTrip']),
        returnTrip: json['returnTrip'] == null ? undefined : FerrySailingOrderFromJSON(json['returnTrip']),
    };
}

export function FerryGetSailingsResponseToJSON(value?: FerryGetSailingsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        total: CurrencyValueToJSON(value['total']),
        outboundTrip: FerrySailingOrderToJSON(value['outboundTrip']),
        returnTrip: FerrySailingOrderToJSON(value['returnTrip']),
    };
}
